"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replacePattern = replacePattern;
/**
 * Replaces the chars in the {@link pattern} with {@link replacements}.
 * @param pattern A string containing chars to be replaced
 * @param replacements An object containing key-value pairs
 * @returns The `pattern` replaced with `replacements`.
 */
function replacePattern(pattern, replacements) {
  return pattern
  // eslint-disable-next-line unicorn/prefer-spread -- there is a bug in babel https://github.com/babel/babel/issues/8298
  .split('').map(char => replacements[char] ?? char).join('');
}
